<template>
  <div>
    <div class="pb-3 border-bottom row justify-content-center">
      <div class="col-12 col-md-6 mb-3 mb-md-0">
        <h5 class="mb-1">Level</h5>
        <b-form-select @change="onSelect" v-model="selectedLevel">
          <b-form-select-option key="no_level" :value="null">
            All Levels
          </b-form-select-option>
          <b-form-select-option
            v-for="(course_level, index) in getCourseLevels"
            :key="index + '_level'"
            :value="course_level.course_level_id"
          >
            {{ course_level.course_level_name }}
          </b-form-select-option>
        </b-form-select>
      </div>
      <div class="col-12 col-md-6">
        <h5 class="mb-1">Category:</h5>
        <b-form-select @change="onSelect" v-model="selectedCategory">
          <b-form-select-option key="no_category" :value="null">
            All Categories
          </b-form-select-option>
          <b-form-select-option
            v-for="(course_category, index) in getCourseCategories"
            :key="index + '_category'"
            :value="course_category.course_category_id"
          >
            {{ course_category.course_category_name }}
          </b-form-select-option>
        </b-form-select>
      </div>
    </div>
    <div id="course-collapse" class="course-collapse">
      <app-collapse>
        <div v-for="(course, index) in courseList" :key="index + '_course'">
          <app-collapse-item title="Title" :ref="'course_' + course.course_id">
            <template #header>
              <Course
                :course="course"
                :id="'course_' + course.course_id"
                :courseCollapse="true"
              />
            </template>
            <Course :course="course" :courseDetail="true" />
          </app-collapse-item>
        </div>
      </app-collapse>
    </div>
  </div>
</template>
<script>
import Course from "./Course";
import {
  BButton,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BImg,
  BFormSelect,
  BFormSelectOption
} from "bootstrap-vue";
import AppCollapse from "@/core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@/core/components/app-collapse/AppCollapseItem.vue";
import Multiselect from "vue-multiselect";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UniversityCourseDetail",
  components: {
    Course,
    BButton,
    AppCollapse,
    AppCollapseItem,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BImg,
    BFormSelect,
    BFormSelectOption,
    Multiselect
  },

  props: {
    courses: {
      type: Array,
      default: []
    },
    university_details: {
      type: Boolean,
      default: true
    },
    collapseCourse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      courseList: this.$props.courses,
      selectedCategory: null,
      selectedLevel: null
    };
  },
  watch: {
    courses() {
      this.onSelect();
    }
  },
  computed: {
    ...mapGetters(["getCourseLevels", "getCourseCategories"])
  },
  methods: {
    ...mapActions(["onGetCourseLevels", "onGetCourseCategories"]),
    onSelect() {
      const courses = this.$props.courses;
      this.courseList = courses.filter(course => {
        let levelFlag = true;
        let categoryFlag = true;
        if (this.selectedCategory) {
          if (course.course_category_id === this.selectedCategory) {
            levelFlag = true;
          } else {
            levelFlag = false;
          }
        }
        if (this.selectedLevel) {
          if (course.course_level_id === this.selectedLevel) {
            categoryFlag = true;
          } else {
            categoryFlag = false;
          }
        }
        return levelFlag && categoryFlag;
      });
    },
    setSavedFilters() {
      const filtersStr = localStorage.getItem("search_filters");
      if (filtersStr) {
        const filters = JSON.parse(filtersStr);
        this.selectedCategory = filters.course_category_ids[0]
          ? filters.course_category_ids[0]
          : null;
        this.selectedLevel = filters.course_level_ids[0]
          ? filters.course_level_ids[0]
          : null;
        if (this.selectedCategory && this.selectedLevel) {
          this.onSelect();
        }
      }
    }
  },
  mounted() {
    const course_id = this.$route.query.course_id;

    if (course_id) {
      this.$nextTick(() => {
        setTimeout(() => {
          const id_str = "course_" + course_id;
          const el = document.getElementById(id_str);
          const course_scroll = document.getElementById("course-collapse");
          course_scroll.scrollIntoView();
          this.$nextTick(() => {
            el.scrollIntoView();
            el.click();
          });
          // window.scrollBy(0, -100);
        }, 1000);
      });
    }
  },
  beforeMount() {
    this.setSavedFilters();
    this.onGetCourseLevels();
    this.onGetCourseCategories();
  }
};
</script>
<style>
.courses-filters {
  display: grid;
  grid-template-columns: 30% 30%;
  grid-column-gap: 3%;
}
.course-collapse {
  height: 100vh;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Search/helper/UniversityCourseDetail.vue